import { loadSpinner } from '/source/_patterns/01-components/spinner/spinner';

export function removeCoupon() {
    let $this = $(this);
    let couponCode = $this.parent().data('coupon');
    let $couponTitle = $('.cart-coupon__badges-title');
    let $couponBadge = $('.coupon-badge');
    let coupon = $this.parent().closest('span');

    coupon.remove();

    if($couponBadge.length === 1) {
        $couponTitle.hide();
    }

    let applyCouponBtns = $('.applyCouponButton');
    if(applyCouponBtns.length) {
        let applyCouponBtn = applyCouponBtns.filter(function() { return this.value === couponCode; });
        if(applyCouponBtn.length) {
            let applyText = applyCouponBtn.data('apply-text');
            applyCouponBtn.text(applyText);
            $(`.coupon_${couponCode}`).show();
        }
    }
}

function closeModal() {
    let $couponModal = $('.cart-coupon__modal');
    $couponModal.modal('hide');
}

function toggleDetails() {
    let $this = $(this);
    let $content = $this.next();
    $content.slideToggle('fast');
    $this.toggleClass('open');
}

function initEventHandlers() {
    let $closeBadge = $('.badge svg');
    let $dismissModal = $('[data-dismiss-modal="coupon-modal"]');
    let $detailsButton = $('.details-button');
    let $spinner = $('.load-spinner');
    $closeBadge.on('click', removeCoupon);
    $dismissModal.on('click', closeModal);
    $detailsButton.on('click', toggleDetails);
    $spinner.on('click', loadSpinner);
}

$(function () {
    initEventHandlers();
});
